import Axios from "axios";
import { handleError } from "../../utils/utils";

export async function getProductsByCategory(categoryId: number) {
  try {
    const products = await Axios.get(
      `/v2/products/category/${categoryId}/products`
    );
    return products.data;
  } catch (error) {
    handleError(error);
  }
}
